var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _vm._m(0);
};

var staticRenderFns = [function () {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "get-otp relative bg-[#E7EDF5] p-[15px_20px_15px_20px]"
  }, [_c('i', {
    staticClass: "el-icon-question absolute w-[24px] h-[24px] text-[24px] text-[#134B96]"
  }), _c('div', {
    staticClass: "pl-[2rem]"
  }, [_c('div', {
    staticClass: "msg-title text-[18px] text-[#134B96] font-semibold"
  }, [_vm._v(" Login Failed ")]), _c('div', {
    staticClass: "my-[0.5rem]"
  }, [_vm._v(" Please contact our customer service to help you ")]), _c('div', [_c('u', [_vm._v("Call Us at +852 6765 4321")])])])]);
}];
export { render, staticRenderFns };